import React, { Component } from "react";
import locateImage from '../../image/locator.png';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PlacesAutocomplete, { geocodeByAddress, getLatLng} from "react-places-autocomplete";
import { reqUestByCity } from '../../actions/FindRecCompany';
import $ from 'jquery'

var componentForm = {
    locality: 'long_name', 
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
    lat: "lat",
    lng: "lng"
};

class LocationSearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            city: "", 
            address: "", 
            currentCity:"",
            coordinate:[],
            defaultSet:true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }


    componentWillMount() {
        let _this = this;
        //let coordinate =[];
        //sessionStorage.setItem("defaultCity", val);
            console.log("localStorage.getItem(\"defaultCity\")", localStorage.getItem("defaultCity"));
        if(localStorage.getItem("defaultCity")===null){
        /* navigator.geolocation.getCurrentPosition(function(position) {
            // Get the coordinates of the current possition.
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            coordinate.push(lng)
            coordinate.push(lat)

            if (position.coords.latitude && position.coords.longitude) {
                fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + position.coords.latitude + ',' + position.coords.longitude + '&key=AIzaSyBnzPuZBr2iOBAtzbL5eYChxGxJw9Za-ak')
                .then ((response) => response.json())
                .then((responseJson) => {
                    var fullAddress = responseJson.results[0].address_components;
                    var place_id = responseJson.results[0].place_id;
                    for (var i in fullAddress) {
                        if (fullAddress[i].types.indexOf("locality") >= 0) {
                            if(sessionStorage.getItem("defaultCity")===null){
                                this.setState({
                                    currentCity:fullAddress[i].long_name,
                                    city: fullAddress[i].long_name,
                                    address: fullAddress[i].long_name,
                                    coordinate:coordinate
                                })
                                sessionStorage.setItem("defaultCity", fullAddress[i].long_name);
                                sessionStorage.setItem("coordinate", JSON.stringify(coordinate));
                            }else{
                                _this.setState({
                                    currentCity:fullAddress[i].long_name,
                                    city: sessionStorage.getItem("defaultCity"),
                                    address: sessionStorage.getItem("defaultCity"),
                                    coordinate: JSON.parse(sessionStorage.getItem("coordinate"))
                                })
                            }  
                        }
                    }
                })
            }
        });
        */
        }else{
            _this.setState({
                currentCity:localStorage.getItem("defaultCity"),
                city: localStorage.getItem("defaultCity"),
                address: localStorage.getItem("defaultCity"),
                coordinate: JSON.parse(localStorage.getItem("coordinate"))
            })
        }          
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect =  (address, placeId) => {
        let coordinate=[];
        geocodeByAddress(address)
            .then(async results => {
                console.log("results[0]", results[0]);
                await getLatLng(results[0])
                    .then(latLng => {
                        console.log("latLng", latLng);
                        coordinate.push(latLng.lng);
                        coordinate.push(latLng.lat);
                    })
                for (var i = 0; i < results[0].address_components.length; i++) {
                    var addressType = results[0].address_components[i].types[0];
                    if (componentForm[addressType]) {

                       if (addressType === 'locality') { 
                            var val = results[0].address_components[i][componentForm[addressType]];
                            var url = window.location.toString();;
                            //url = decodeURIComponent((str + '').replace(/\+/g, '%20'));
                            var city =  localStorage.getItem("defaultCity").replace(/\s+/g,'');
                            let str = val.replace(/\s+/g,'');
                            var res = url.replace(city, str);
                            localStorage.setItem("defaultCity", val);
                            localStorage.setItem("coordinate", JSON.stringify(coordinate));
                            window.history.replaceState(null, null, res);
                            this.setState({ "address": val,coordinate:coordinate })
                        }
                    }
                }
            })
            .catch(error => console.error('Error', error));
    };

    findData = () => {
        this.props.props.reqUestByCity(this.state.address)
    }

    ChangeCity = () => {
        localStorage.setItem("changeCity", true)
       this.setState({
            address:"",
            defaultSet:false
       });
        $("#searchPlace").focus();
    }


    render() {
 
        let validateCity="";
        if(localStorage.getItem("changeCity")==="false"){
            validateCity=true;
        }else{
            validateCity=false;
        }
        
        const searchOptions = {
            types: ['(cities)'],
            componentRestrictions: { country: "us" }
        }
        return (

            <PlacesAutocomplete
                className="fnew-control"
                value={this.state.address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (

                    <div className="autocomplete-container wid-reduce">
                        <span> Your current search defaults to
                            {validateCity &&
                                <span className="dfultCity">&nbsp;{this.state.address}</span>
                            }
                        </span> 
               
                        <div className="input-group">
                            <div className="block-v">
                                <span className="input-group-addon">
                                    <img className="locate-image post-ab" src={locateImage} alt="Location"/> 
                                </span>
                            </div>
                            {!validateCity &&
                                <input
                                    {...getInputProps({
                                    placeholder: "Search Places",
                                    id:"searchPlace",
                                    className: "location-search-input fnew-contro form-control"
                                    })}
                                />
                            }

                            <a href="#">
                                <span className="change-city-b" onClick={()=>this.ChangeCity()}>Change City</span>
                            </a>
                            {/* <a onClick={this.findData.bind(this,"city")}><span className="input-group-addon searchIco"><i className="fa fa-search"></i></span></a>*/}
                        </div>

                        <div className="autocomplete-dropdown-container search-suggestion-list">
                            {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                  ? "suggestion-item--active"
                                  : "suggestion-item";
                                    // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
                                  : { backgroundColor: "#ffffff", cursor: "pointer" };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                            })}
                        </div>
                  </div>
                )}
            </PlacesAutocomplete>
        );
    }
}


class CitySuggestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = { places: [] };
        this.showPlace = this.showPlace.bind(this);
        this.mapRef = React.createRef();
    }

    showPlace(place) {
        this.setState(prevState => ({
            places: [...prevState.places, place]
        }));
        this.mapRef.current.map.setCenter(place.geometry.location);
    }

      
    render() {
        return (
            <div className="map-container"> 
                <LocationSearchInput className="fnew-control" props={ this.props } onPlaceChanged={this.showPlace} />
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {

    }
}
export default withLocalize(withRouter(connect(mapStateToProps, {
    reqUestByCity
})(CitySuggestion)));;


// WEBPACK FOOTER //
// ./src/components/Layout/CitySuggestion.js